import { Component, ErrorInfo, ReactNode } from 'react';
import { isLocalhost } from 'src/app-config';
import { logServices } from 'src/services';
import { typeUser } from '@monorepo/models';
import { useGetCurrentUser } from 'src/custom-hooks';

type ErrorBoundaryProps = {
    children: ReactNode;
    user: typeUser;
};

type ErrorBoundaryState = {
    hasError: boolean;
};

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(_: Error): ErrorBoundaryState {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        if (!isLocalhost) {
            const _ = logServices.SaveFrontendException(this.props.user, error, errorInfo);  // do not await
        }
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className={'text-center'}>
                    <h1 className={'px-4 mt-3'}>
                        Hubo un error. Ya estamos trabajando en solucionarlo. Recargar la pantalla para continuar.
                    </h1>
                    <button className={'btn btn-general-blue m-3'} onClick={() => {window.location.reload();}}>
                        Recargar
                    </button>
                    <button className={'btn btn-general-blue'} onClick={() => {window.location.href = '/';}}>
                        Volver al Inicio
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}

export const ErrorBoundaryWrapper = ({ children }: { children: ReactNode }) => {
    const user = useGetCurrentUser();

    return (
        <ErrorBoundary user={user}>
            {children}
        </ErrorBoundary>
    );
}
